<template>
    <div class="searchContent">
        <a-affix>
            <a-card :title="this.$slots.default">
                <a-form layout="inline" @submit="handleSubmit" :form="form">
                    <a-form-item label="域名">
                        <a-input
                            v-decorator="[
                                'domainurl',
                                {
                                    initialValue: record.domainurl || '',
                                }
                            ]"
                            placeholder="请输入域名"
                        ></a-input>
                    </a-form-item>

                    <a-form-item>
                        <a-button
                            type="primary"
                            htmlType="submit"
                            :key="this.loading.key"
                            :loading="this.loading.effects['domainname/select']"
                        >查询</a-button>
                        <v-resetbutton
                            :key="Math.random()"
                            :loading="this.loading.effects['domainname/select']"
                            :redirect="{path:'/domainname/list'}"
                            class="ml15"
                        >重置</v-resetbutton>
                    </a-form-item>
                </a-form>
            </a-card>
        </a-affix>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: this.$form.createForm(this),
            record: this.$route.query || {}
        };
    },
    computed: {},
    methods: {
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (err) return;
                this.$router.push({
                    path: "list",
                    query: values
                });
            });
        }
    },
    mounted() {}
};
</script>

<style scoped>
.ant-form-inline .ant-form-item {
    margin-bottom: 20px;
}
.searchContent {
    box-shadow: 0 0 5px #e8e8e8;
}
</style>